import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import {
  type OpalApiRequestParams,
  type OpalApiResponseDocument,
} from '../../schema'

type ReadLabelSetOperation = 'ReadLabelSetsV2'

export type ReadLabelSetV2ResponseData = OpalApiResponseDocument<
  ReadLabelSetOperation,
  200
>

export type ReadLabelSetV2RequestParams =
  OpalApiRequestParams<ReadLabelSetOperation>

export const readLabelSets = async (params: ReadLabelSetV2RequestParams) => {
  const url = new URL('/label_sets/v2', window.location.origin)
  url.search = queryString(params?.query)

  return HttpClient()
    .get<ReadLabelSetV2ResponseData>(url.toString())
    .then((res) => res.data)
}
